// take tour types
export const TAKE_TOUR_TYPES = {
  DOCCHAT_HOMEPAGE: 'DOCCHAT_HOMEPAGE',
  DOCCHAT_CHAT_VIEWER: 'DOCCHAT_CHAT_VIEWER',
};
